import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';

@Component({
  selector: 'app-tekme-add-dialog',
  templateUrl: './tekme-add-dialog.component.html',
  styleUrls: ['./tekme-add-dialog.component.scss']
})
export class TekmeAddDialogComponent implements OnInit {
  @Input() competition: any = {
    competition_name: '',
    competition_date: '',
    is_teiler: false
  };
  @Input() isEditMode = false;

  @Output() save = new EventEmitter<any>();
  @Output() cancel = new EventEmitter<void>();

  constructor(private http: HttpClient) {}

  ngOnInit(): void {
    // If not editing, reset the form
    if (!this.isEditMode) {
      this.competition = {
        competition_name: '',
        competition_date: '',
        is_teiler: false
      };
    }
  }

  onSave() {
    const payload = {
      competition_name: this.competition.competition_name,
      competition_date: this.competition.competition_date,
      is_teiler: !!this.competition.is_teiler
    };
    const token = localStorage.getItem('access_token');
    const unitId = localStorage.getItem('unit_id');
    const headers = token ? new HttpHeaders({ Authorization: `Bearer ${token}` }) : undefined;
    const params = unitId ? new HttpParams().set('unit_id', unitId) : undefined;

    if (this.isEditMode && this.competition.competitionId) {
      // PUT update
      const apiUrl = `https://testapi.ovh/api/strelstvo/competitions/${this.competition.competitionId}`;
      this.http.put(apiUrl, payload, { headers, params }).subscribe(
        (response) => {
          this.save.emit(response);
        },
        (error) => {
          alert('Napaka pri urejanju tekmovanja!');
        }
      );
    } else {
      // POST add
      const apiUrl = 'https://testapi.ovh/api/strelstvo/competitions';
      this.http.post(apiUrl, payload, { headers, params }).subscribe(
        (response) => {
          this.save.emit(response);
        },
        (error) => {
          alert('Napaka pri dodajanju tekmovanja!');
        }
      );
    }
  }

  onCancel() {
    this.cancel.emit();
  }
}